import { render, staticRenderFns } from "./StatisticsTradeTransactionsChart.vue?vue&type=template&id=5764d3af&scoped=true&"
import script from "./StatisticsTradeTransactionsChart.vue?vue&type=script&lang=js&"
export * from "./StatisticsTradeTransactionsChart.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsTradeTransactionsChart.vue?vue&type=style&index=0&id=5764d3af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5764d3af",
  null
  
)

export default component.exports